




















































































































import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { StripeConnectOptions } from '@core/interfaces/stripe-connect-options';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { stripe_connect_options } from '@/config/stripe_connect_options';

@Component({
  name: 'bpc-stripe-connect-options-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-switch': Switch,
  },
})
export default class StripeConnectOptionsForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  // @Prop({ type: String, default: '' }) readonly myStrProp: string;

  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}
  // DATA
  public formModel: StripeConnectOptions = null;
  // COMPUTED

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get savePath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('superadmin-options')}/${
      this.tenantId
    }/stripe-connect`;
  }

  get fetchPath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('superadmin-options')}/${
      this.tenantId
    }/stripe-connect`;
  }

  get fieldsConfig() {
    return stripe_connect_options;
  }

  get moduleFieldsConfig() {
    return Object.values(stripe_connect_options).filter(item =>
      item.fieldPath.includes('modules.'),
    );
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }
  // METHODS

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  // WATCHERS
}
